
import { SupabaseClient } from '@supabase/supabase-js';

/**
 * Type-safe wrapper for Supabase table operations
 * This utility helps us work around type issues without modifying the supabase/types.ts file
 */
export function typedSupabaseTable<T>(client: SupabaseClient, tableName: string) {
  const query = client.from(tableName);
  
  // The returned object now includes all the methods we need with proper typing
  return query as unknown as {
    select: (columns?: string) => any;
    insert: (values: Partial<T> | Partial<T>[]) => any;
    update: (values: Partial<T>) => any;
    delete: () => any;
    eq: (column: string, value: any) => any;
    single: () => Promise<{ data: T | null; error: any }>;
    order: (column: string, options?: { ascending?: boolean }) => any;
  };
}

// Helper function for the RPC is_admin function that's causing a type error
export function typedRpcFunction<T>(client: SupabaseClient, functionName: string, params?: object) {
  return client.rpc(functionName, params) as unknown as Promise<{ data: T; error: any }>;
}
